module.exports = __webpack_public_path__ + "static/media/minus-square.a14598e0.svg";